import {SelectOptionType} from "../../types/admin/selectOptionType";

// eslint-disable-next-line no-shadow
export enum Color {
  RED = 1,
  YELLOW = 2,
  GREEN = 3,
  PURPLE = 4,
  ORANGE = 5,
  BLUE = 6,
  PINK = 7,
  YELLOW_GREEN = 8,
}

export const getColorText = (color: Color): string => {
  let text: string = '';

  switch (color) {
    case Color.RED:
      text = '赤';
      break;
    case Color.YELLOW:
      text = '黄';
      break;
    case Color.GREEN:
      text = '緑';
      break;
    case Color.PURPLE:
      text = '紫';
      break;
    case Color.ORANGE:
      text = 'オレンジ';
      break;
    case Color.BLUE:
      text = '青';
      break;
    case Color.PINK:
      text = 'ピンク';
      break;
    case Color.YELLOW_GREEN:
      text = '黄緑';
      break;
    default:
      // ToDo: Errorクラス、エラーメッセージをもっと適当なものに
      throw new Error(`想定していないColor（${color}）が渡されました。`);
  }

  return text;
};

export const getColorSelectOptions = (): SelectOptionType[] => {
  return (Object.keys(Color) as Array<keyof typeof Color>)
    .map(key => parseInt(key, 10))
    .filter( key => !Number.isNaN(key))
    .map((key: number) => {
      const selectOption: SelectOptionType = {
        value: key,
        label: getColorText(key),
      }
      return selectOption;
    });
}